<template>
    <span class="discount-overview">
        <div v-if="cartDiscountAmount > 0" class="discount-overview__item" tabindex="0">
            <span class="discount-overview__discount-text">{{ $ml.get('cartDiscount') }} {{ cartPercentage }}  </span>
            <strong class="discount-overview__discount-price">- {{ formatPrice(cartDiscountAmount) }}</strong>
        </div>
        <div v-if="paymentMethodDiscount > 0" class="discount-overview__item" tabindex="0">
            <span class="discount-overview__discount-text"> {{ $ml.get('discountOn') }} {{ $ml.get(getPaymentMethodTranslationParameterName) }} {{ paymentMethodPercentage }}</span>
            <strong class="discount-overview__discount-price"> - {{ formatPrice(paymentMethodDiscount) }}</strong>
        </div>
    </span>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moneyHelper from '@/helpers/moneyHelper';
  import translationParameterHelper from '@/config/lang/helpers/translationParameterHelper.js';

  export default {
      computed: {
          ...mapGetters({               
              cartDiscountAmount: 'discount/getCartDiscountAmount',
              paymentMethodDiscount:'discount/getPaymentMethodDiscountAmount',
              cartDiscount : 'cart/getCartDiscount',
              paymentMethodDiscountPercentage: 'payment/getDiscount',
              selectedPaymentTypeId: 'payment/getSelectedPaymentTypeId'
          }),
          cartPercentage(){
              if(this.cartDiscount && this.cartDiscount.TypeId == 2 && this.cartDiscount.Percentage > 0)
                  return `: ${this.cartDiscount.Percentage}%`;
              return '';
          },

          paymentMethodPercentage(){
              if (this.paymentMethodDiscountPercentage && this.paymentMethodDiscountPercentage > 0)
                  return `: ${this.paymentMethodDiscountPercentage}%`;
              return '';
          },

          getPaymentMethodTranslationParameterName() {
              return translationParameterHelper
                  .getPaymentMethodTranslationParameterName(this.selectedPaymentTypeId);
          }

      },

      methods: {
          formatPrice(unitPrice) {
              return `R$ ${moneyHelper.formatToPrice(unitPrice)}`;
          },

          parseCents(amount){
              return amount / 100;
          }
      }

  };
</script>

<style lang="scss" scoped>
  .discount-overview {
      display: block;
      margin-top: 24px;

      &__item {
        display: flex;
        justify-content: space-between;

        &:not(:first-of-type) {
          margin-top: 16px;
        }
      }

      &__discount-text {
          font-size: 16px;
          font-weight: 500;
          color: #000;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          @media screen and (min-width: 1025px) {
          }
      }

      &__discount-price {
          font-size: 16px;
          font-weight: 500;
          color: #00855D;

          white-space: nowrap;
          @media screen and (min-width: 1025px) {
          }
      }

  }

</style>